module.exports = __webpack_public_path__ + "assets/ic_toast_close.ff3c1fff.svg";